module.exports = "/assets/site/images/bicikli.jpg?8e7b5472c1596348a44964602c106e76";